const HOSTS_URL = '/hosts';

export function hostsApi(): string {
  return HOSTS_URL;
}

export function hostTrendsApi(): string {
  return `${hostsApi()}/trends`;
}

export function hostByCountries(): string {
  return `${hostsApi()}/by-countries`;
}

export function hostSummaryStatistic(): string {
  return `${hostsApi()}/summary`;
}
